import { BREAKPOINTS } from "configs/constants";
import { BaseImageProps } from "../types";
import React from "react";

export const convertBaseImageProps = ({
  alt,
  customClass,
  slug,
  imageDesktop,
  imageMobile,
  loadingType = "lazy",
  featchPriority = "auto",
}: BaseImageProps) => {
  return {
    slug,
    alt: alt || "",
    customClass: customClass || undefined,
    imageDesktop,
    imageMobile,
    loadingType,
    featchPriority,
  };
};

const BaseImage = ({
  alt,
  customClass,
  imageDesktop,
  imageMobile,
  loadingType,
  featchPriority,
}: BaseImageProps) => {
  const image = (
    <img
      src={imageDesktop}
      alt={alt}
      className={customClass}
      loading={loadingType !== "lazy" ? loadingType : undefined}
      // TODO: fetchpriority
      // eslint-disable-next-line react/no-unknown-property
      fetchpriority={featchPriority !== "auto" ? featchPriority : undefined}
    />
  );

  return imageMobile ? (
    <picture>
      <source media={`(max-width:${BREAKPOINTS.sm}px)`} srcSet={imageMobile} />
      {image}
    </picture>
  ) : (
    image
  );
};

export default BaseImage;
